import { axios } from '@ben/api/axios';
import type { IModularBenefitsListItem } from '@ben/shared/types/columbia';

export interface IModularBenefitsList {
  count: number;
  next: string | null;
  previous: string | null;
  results: IModularBenefitsListItem[];
}

export const getModularBenefitsList = async (
  page: number,
  pageSize: number,
  sortBy?: string,
  search?: string
): Promise<IModularBenefitsList> => {
  let queryString = `benefits/?page=${page}`;
  if (pageSize) {
    queryString += `&page_size=${pageSize}`;
  }
  if (sortBy) {
    queryString += `&ordering=${sortBy}`;
  }
  if (search) {
    queryString += `&search=${search}`;
  }

  const response = await axios.get<IModularBenefitsList>(queryString);
  return response?.data;
};
